import { useMemo } from 'react';

const createSkeletonRow = (index) => ({
  index,
  original: {
    id: `skeleton-${index}`,
    index,
    isSkeleton: true,
  },
  options: {
    showLoader: true,
  },
  rowId: `skeleton-${index}`,
  id: `skeleton-${index}`,
  contact: {
    id: `skeleton-${index}`,
    fullName: '',
    profilePicUrl: '',
    isSkeleton: true,
  },
  organization: {
    id: `skeleton-${index}`,
    name: '',
    logoUrl: '',
    isSkeleton: true,
  },
  jobTitle: '',
  movementType: '',
  date: '',
  isSkeleton: true,
});

export const useMovementsTableRows = (data, showSkeleton = false) =>
  useMemo(() => {
    if (showSkeleton) {
      return Array.from({ length: 10 }, (_, index) => createSkeletonRow(index));
    }

    return (
      data?.map((movement, index) => {
        const contact = movement.contact?.attributes
          ? {
              id: movement.contact.id,
              fullName: movement.contact.attributes.fullName || movement.contact.attributes.full_name,
              profilePicUrl: movement.contact.attributes.profilePicUrl || movement.contact.attributes.profile_pic_url,
            }
          : movement.contact || {};

        let organization = {};
        if (movement.organization?.attributes) {
          organization = {
            id: movement.organization.id,
            name: movement.organization.attributes.name,
            logoUrl: movement.organization.attributes.logoUrl || movement.organization.attributes.logo_url,
            slug: movement.organization.attributes.slug,
          };
        } else if (movement.organization) {
          // eslint-disable-next-line prefer-destructuring
          organization = movement.organization;
        }

        return {
          index,
          original: {
            ...movement,
            index,
            contact,
            organization,
          },
          options: {
            showLoader: false,
            type: 'private',
          },
          rowId: movement.id,
          id: movement.id,
          contact,
          organization,
          jobTitle: movement.jobTitle || '',
          movementType: movement.movementType || '',
          date: movement.date || '',
          companyName: movement.companyName || organization.name || '',
        };
      }) ?? []
    );
  }, [data, showSkeleton]);
